/* lua.js generated code 0.3.0 */

var UserProductTypeBase = require("clover/logic/userProduct/UserProductTypeBase")
let AIPkgManager = require("activity/AIPackage/AIPkgManager");

var UserProductTypeWIN32 = xClass("UserProductTypeWIN32", UserProductTypeBase)
UserProductTypeWIN32.prototype.getProductInfo = function (successCallback, failCallback, timeoutCallback, cancelCallback) {
    var self = this
    if (self.finishLoadOnline) {
        self.finishLoadOnline = false
        if (type(successCallback) === "function") {
            var ret = table()
            for (var k in self.productInfo) {
                var v = self.productInfo[k]
                table.insert(ret, v)
            }
            successCallback(ret)
        }
        return 
    }
    var productMeta = clone(MetaManager.getInstance().product || table())
    //let isFirstPay = UserManager.getInstance().isFirstPay() > 0 ? true : false
    self.productInfo = table()
    for (let i in productMeta) {
        let v = productMeta[i]
        if (!v) {
            continue
        }
        if (v.show === 1) {
            let goodsMeta = MetaManager.getInstance().getGoodsMeta(v.goodsId || 0)
            //console.log(`[####]get googsid `+ v.goodsId)
            //cc.log("[####]goodsmeta ", goodsMeta)
            if (type(goodsMeta) === "table" && goodsMeta.on === 1) {
                //if (isFirstPay) {
                    //if (v.firstPay === 1) {
                        self.productInfo[v.id] = v
                    //}
                //}else if(!v.firstPay){
                    //self.productInfo[v.id] = v
                //}
            }
        }else if( v.show === 0 && v.itemKey){
            self.productInfo[v.id] = v
        }
    }
    self.finishLoadOnline = true
    //cc.log("productInfo:", self.productInfo)
    self.getProductInfo(successCallback, failCallback, timeoutCallback, cancelCallback)
}
UserProductTypeWIN32.prototype.getCashInfo = function (successCallback, failCallback, timeoutCallback, cancelCallback) {
    var self = this
    self.getProductInfo(function (ret) {
        if (type(successCallback) === "function") {
            var res = table([1, "list", table()])
            for (var i = 1, v = ret[1]; v; i++, v = ret[i]) {
                if (!v.tag) {
                    var meta = clone(v)
                    meta.price = meta.price * 100
                    table.insert(res.list, meta)
                }
            }
            table.sort(res.list, function (a, b) {
                return a.price < b.price
            })
            successCallback(table([0, res]))
        }
    }, failCallback, timeoutCallback, cancelCallback)
}
UserProductTypeWIN32.prototype.canBuyProduct = function (productId) {
    var self = this
    if (!self.productInfo[productId]) {
        return [false, ZooErrorCode.BUY_PRODUCTID_INVALID]
    }
    return [true]
}
UserProductTypeWIN32.prototype.deal = function (productId, successCallback, failCallback, cancelCallback, source = ModuleName.BUY_RMB_COINS, dcCashData = null) {
    var self = this
    let loadId = LoadingPanelLogic.getInstance().add("购买中，请耐心等待...", cancel)
    function removeAnim() {
        if (loadId) {
            LoadingPanelLogic.getInstance().remove(loadId)
            loadId = null
        }
    }
    function fail(event) {
        removeAnim()
        if (type(failCallback) === "function") {
            failCallback(event)
        }
    }
    function cancel() {
        removeAnim()
        if (type(cancelCallback) === "function") {
            cancelCallback()
        }
    }
    function onSuccess(special) {
        let product_str, rmb, itemid, dcGoodsId, ext
        if (special === "aiPackage") {
            itemid = productId;
            let productMeta = AIPkgManager.getInstance().getPackageMeta(productId);
            cc.log("wx buy->deal productMeta:", productMeta)
            if (!productMeta) {
                fail()
                return;
            }
            product_str = productMeta.productId;
            rmb = productMeta.rmb / 10; // ai礼包价格使用分计算的，需要标准化为角
            dcGoodsId = productMeta.package_id;
        }else if (special == ModuleName.FESTIVAL_8TH_SHOP ){
            product_str = dcCashData.productId
            dcGoodsId = dcCashData.goodsId
            rmb = dcCashData.price * 10
            
        } else if (special == ModuleName.SECRET_SHOP){
            dcGoodsId = dcCashData.goodsId
            rmb = dcCashData.price * 10
            product_str = dcCashData.productId
        } else if (special == ModuleName.SALVAGE_GIFT){
            dcGoodsId = dcCashData.goodsId
            rmb = dcCashData.price * 10
        }else if(special == ModuleName.TRINITY_GIFT_BAG) {
            dcGoodsId = productId;
            rmb = dcCashData.price * 10;
            product_str = dcCashData.extProductId
        }else {
            itemid = GameProxy.getInstance().getItemIDById(productId)
            let productMeta = self.productInfo[productId]
            if (!productMeta) productMeta = MetaManager.getInstance().getProductMetaByID(productId)
            cc.log("[购买] UserProductTypeWIN32.prototype.deal productMeta:", JSON.stringify(productMeta))
            product_str = productMeta.productId
            rmb = productMeta.cash
            dcGoodsId = productMeta.goodsId;
            ext = productMeta.ext;
        }
        
        function success(payData) {
            let tradeId = payData && payData.orderId || `${UserManager.getInstance().uid}_${goodsId}_${Localhost.timeInSec()}`;
            removeAnim()
            UserManager.getInstance().addPayRecord(rmb / 10);
            GoldElysiumManager.getInstance().addPayRecord(rmb / 10)
            DCAssist.dc4UseCurrencyWin32(dcGoodsId, 1, source, rmb * 10, tradeId) //source作为sceneName传入 应要求 scene source module  等都最后记录到category中
            let extraItems = table()
            // if (UserManager.getInstance().isExtraCashBuffCanUse() && self.productInfo[productId].firstPay) {
            // 抢Q币活动的恶心代码，应该直接配置商品为最佳
            if (special !== "aiPackage") {
                if (UserManager.getInstance().isExtraCashBuffCanUseLessLimit() && self.productInfo[productId].firstPay) {
                    let extraCash = self.productInfo[productId].cash * UserManager.getInstance().getExtraCashBuffRate()
                    if (extraCash > 0) {
                        extraItems.push({itemId : ItemType.GOLD, num : extraCash})
                    }
                }
            }
            UserDeal.getInstance().deliverGoods(dcGoodsId, 1, source, {"trade_id": tradeId, "item_worth": ItemWorth.RMB}, extraItems)
            if (dcCashData) {
                DCAssist.dc4GetCashGoods(dcCashData.session, 
                    dcCashData.scence, 
                    dcCashData.hasOwnProperty("goodsId")? dcCashData["goodsId"]: dcGoodsId,
                    dcCashData.entry,
                    dcCashData.hasOwnProperty("price")? dcCashData["price"]: rmb / 10,
                    null,
                    dcCashData
                );
            }
            if (type(successCallback) === "function") {                
                successCallback(payData)
            }
        }
        // payment.buy(uid, product_str, itemid, rmb, rmb, success, fail, cancel)
        let data = {
            uid : UserManager.getInstance().uid,
            productId : product_str,
            itemId : itemid,
            score : rmb
        }
        if (special === "aiPackage") {
            if(itemid > 7000000) {
                data.ext = {
                    aiGiftBagDailyBindId: itemid,
                }
            }else{
                data.ext = {
                    aiGiftBagId: AIPkgManager.getInstance().getLeaderId(itemid),
                    aiGiftBagType: AIPkgManager.getInstance().getPackageType(itemid)
                }
            }
        }else if (ext){
            data.ext = ext;
        }else if (dcCashData.ext){
            data.ext = dcCashData.ext
        }
        cc.log("[购买] UserProductTypeWIN32.prototype.deal data:", JSON.stringify(data))
        let onFailCb = ()=>{
            removeAnim()
            hideGlobalMask("aiRevive");//ai礼包屏蔽了点击 这里得放开不然会导致 弹框无法关闭
            hideGlobalMask("aiMarket");
            require("clover/sns/SnsProxy").getInstance().showDialog({
                text: getText("error.tip.760810"),
                needOkBtn: true,
                okBtnText: "确定",
            }, () => {
                if (type(fail) === "function") {
                    fail()
                }
            })
        }
        let onSuccessCb = (evt)=>{
            cc.log("[购买] UserProductTypeWIN32.prototype.deal WanbaCheckOrderHttp evt:", evt)
            if (evt.data.canOrder){
                GameProxy.getInstance().buyProduct(data, success, fail, cancel, false)
                var snsProxy = require("clover/sns/SnsProxy").getInstance()
                let isQQIOS = snsProxy.isQQIOS()
                if (isQQIOS) {
                    document.addEventListener("cloverVisibilityChange", function () {
                        removeAnim()
                    }, {once:true})
                }
            }else{
                onFailCb();
            }
        }

        if (getCurrentPlatform() == XcloverPlatform.huawei){
            console.log("huawei no checkorder")
            onSuccessCb({data:{canOrder: true}})
            return
        }

        let http = WanbaCheckOrderHttp.new();
        http.addEventListener(Events.kComplete, onSuccessCb);
        http.addEventListener(Events.kError, onFailCb);
        http.addEventListener(Events.kCancel, onFailCb);
        http.load();
    }
    if (AIPkgManager.IsAiPackage(productId)) {
        onSuccess("aiPackage");
    }else if (dcCashData && dcCashData.scence == ModuleName.FESTIVAL_8TH_SHOP){
        onSuccess(ModuleName.FESTIVAL_8TH_SHOP);
    }else if (dcCashData && dcCashData.scence == ModuleName.SECRET_SHOP){
        onSuccess(ModuleName.SECRET_SHOP);
    }else if(TrinityGiftBagManager.getInstance().isTrinityGiftBag(productId)) {
        onSuccess(ModuleName.TRINITY_GIFT_BAG);
    } else if (SalvageGiftManager.getInstance().isSalvageGift(productId)){
        onSuccess(ModuleName.SALVAGE_GIFT);
    } else {
        let productMeta = MetaManager.getInstance().getProductMetaByID(productId)
        if ( productMeta.giftBagId && productMeta.giftBagId !== 0) {
            let http = ValideGiftBagHttp.new(true)
            http.addEventListener(Events.kComplete, onSuccess)
            http.addEventListener(Events.kError, fail)
            http.addEventListener(Events.kCancel, cancel)
            http.load(productMeta.giftBagId)
        }else {
            onSuccess()
        }
    }
}
module.exports = UserProductTypeWIN32
